<template>
    <vue-draggable-resizable
        class="custom-resizable"
        :draggable="false"
        :resizable="!disabledResize"
        :handles="handles"
        :onResize="onResize"
        :maxWidth="maxWidth"
        :minWidth="minWidth"
        :w="width"
    >
        <slot />
    </vue-draggable-resizable>
</template>
<script>
import VueDraggableResizable from "vue-draggable-resizable";
import _ from "lodash";

export default {
    name: "ResizableContent",
    components: {
        VueDraggableResizable,
    },
    props: {
        width: {
            type: [String, Number],
            default: 0,
        },
        minWidth: {
            type: Number,
            default: null,
        },
        maxWidth: {
            type: Number,
            default: null,
        },
        handles: {
            type: Array,
            default: () => [],
        },
        disabledResize: {
            type: Boolean,
            default: false,
        },
        onResize: {
            type: Function,
            default: () => _.noop,
        },
    },
    data: () => ({
        touched: false,
        beforeDestroyListeners: [],
        listeners: [],
    }),
    methods: {},
    mounted() {},
};
</script>
<style>
.resizable-content {
    width: auto !important;
}

.custom-resizable {
    position: relative;
    width: 100%;
    height: 100% !important;
    transform: none !important;

    .handle {
        position: absolute;
        top: 0;
        cursor: col-resize;
        display: block !important;
        z-index: 1;

        &:hover,
        &:focus,
        &:active {
            background: var(--border-neutral-default);
        }

        &.handle-mr {
            right: 0px;
            width: 5px;
            height: 100%;
        }

        &.handle-ml {
            left: 0px;
            width: 5px;
            height: 100%;
        }
    }
}
</style>
